import {ClipsFullscreenBlock} from "./lib/ClipsFullscreenBlock";

export const tags = {
    "clips-fullscreen": ClipsFullscreenBlock
};

export const lazyChunks = {
//    "clips-fullscreen": somehowImportedChunksModule
};
